import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { BsSearch, BsLink } from 'react-icons/bs';

import { pageRoute } from '../../../config/routes/pages';
import { DetailCardType } from '../../../types/content';
import AnimatedDiv from '../animated-div/animated-div';
import { CardModal } from '../card-modal/card-modal';
import * as S from './styles';

export function NameOnlyCard(props: DetailCardType) {
  const {
    ctaLink,
    hasClickableImage = false,
    hasClickableName = false,
    hasIconsOnHover = false,
    imageHeight = 80,
    imageModalHeight = 55,
    imagePadding = 'p-6',
    src,
    value
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  function handleOpenModal() {
    setIsOpen(true);
  }

  function handleImageClick() {
    if (hasClickableImage) setIsOpen(true);
    return;
  }

  const imageSrc = Array.isArray(src) ? src[0] : src;

  const iconsOnHover = hasIconsOnHover && (
    <div className="flex absolute z-10 top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 space-x-2 invisible group-hover:visible">
      <div className="text-white border-2 border-white rounded-full cursor-pointer hover:text-primaryBlue hover:bg-white">
        <BsSearch
          className="text-header3 p-3 lg:text-header4 lg:p-2"
          onClick={handleOpenModal}
        />
      </div>
      <Link href={`${pageRoute.RECIPES}/${ctaLink}`} passHref>
        <a className="text-white border-2 border-white rounded-full cursor-pointer hover:text-primaryBlue hover:bg-white z-20">
          <BsLink className="text-header3 p-3 lg:text-header4 lg:p-2" />
        </a>
      </Link>
    </div>
  );

  const nameTag = hasClickableName ? (
    <Link href={`${pageRoute.RECIPES}/${ctaLink}`} passHref>
      <a className="flex justify-center items-center font-MuseoSans300 font-bold text-caption py-3 uppercase">
        {value}
      </a>
    </Link>
  ) : (
    <p className="flex justify-center items-center font-MuseoSans300 font-bold text-caption py-3 uppercase">
      {value}
    </p>
  );

  return (
    <S.Container hasIconsOnHover={hasIconsOnHover}>
      <AnimatedDiv
        className={`flex flex-col border border-black ${imagePadding}`}
      >
        <div
          className="image-container w-full block cursor-pointer relative group"
          onClick={handleImageClick}
        >
          <Image
            alt={value}
            blurDataURL="/icons/blur-placeholder.png"
            height={imageHeight}
            layout="responsive"
            objectFit="contain"
            placeholder="blur"
            src={imageSrc}
            width="100%"
          />
          {iconsOnHover}
        </div>
        <CardModal
          imageHeight={imageModalHeight}
          isOpen={isOpen}
          src={src}
          setIsOpen={setIsOpen}
        />
        {nameTag}
      </AnimatedDiv>
    </S.Container>
  );
}

export default NameOnlyCard;
